export const CLOUD_NAME = 'drbz9cp5d'
export const CLOUD_FOLDER = 'ga-elite-concrete'

// Cloudinary tag list endpoint — requires:
// 1. Cloudinary Settings → Security → Enable "Resource list" delivery type
// 2. Images tagged with "ga-elite-concrete" (or matching folder name)
export const LIST_URL = `https://res.cloudinary.com/${CLOUD_NAME}/image/list/${CLOUD_FOLDER}.json`

// Inserts Cloudinary transforms into an existing URL for fast thumbnail loading
export const optimizeUrl = (url: string, transforms = 'c_fill,w_480,h_360,q_auto,f_auto'): string =>
  url.replace('/upload/', `/upload/${transforms}/`)
